import { cn } from "@/lib/utils";
import rankaroLogo from "@/assets/rankaro-logo.png";

interface RankaroLogoProps {
  size?: number;
  className?: string;
  variant?: "icon" | "full";
}

const RankaroLogo = ({ size = 36, className }: RankaroLogoProps) => {
  // The new logo already contains icon + wordmark
  // Aspect ratio ~4.5:1 based on original image dimensions
  const width = Math.round(size * 4.5);
  return (
    <img
      src={rankaroLogo}
      alt="Rankaro"
      width={width}
      height={size}
      style={{ height: size, width: 'auto' }}
      className={cn("flex-shrink-0", className)}
    />
  );
};

export default RankaroLogo;
